(function () {
  var FORM_ID = 'U32CGs';
  var KLAVIYO_SRC =
    window.WF_KLAVIYO_ONSITE_SRC ||
    'https://static.klaviyo.com/onsite/js/VKwfFU/klaviyo.js?company_id=VKwfFU';

  function loadKlaviyo() {
    if (window.klaviyo || document.querySelector('script[data-wf-klaviyo="1"]')) return;

    var script = document.createElement('script');
    script.async = true;
    script.src = KLAVIYO_SRC;
    script.setAttribute('data-wf-klaviyo', '1');
    document.head.appendChild(script);
  }

  function markDismissButtons(form) {
    form.querySelectorAll('button.klaviyo-form-button').forEach(function (btn) {
      if (/maybe next time/i.test(btn.textContent.trim())) {
        btn.classList.add('wf-klaviyo-dismiss-text');
      }
    });
  }

  function watchForm() {
    if (window.__wfKlaviyoFormWatcher) return;
    window.__wfKlaviyoFormWatcher = true;

    var observer = new MutationObserver(function () {
      document.querySelectorAll('[data-testid="klaviyo-form-U32CGs"]').forEach(markDismissButtons);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function openForm() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
    setTimeout(function () {
      var form = document.querySelector('[data-testid="klaviyo-form-U32CGs"]');
      if (form) markDismissButtons(form);
    }, 300);
  }

  function handleClick(event) {
    var trigger = event.target.closest('[data-wf-klaviyo-form]');
    if (!trigger) return;

    event.preventDefault();
    loadKlaviyo();
    openForm();
  }

  function handleIntent(event) {
    if (event.target.closest('[data-wf-klaviyo-form]')) loadKlaviyo();
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('pointerenter', handleIntent, true);
  document.addEventListener('focusin', handleIntent);
  watchForm();
})();
